import ProductAside from './product-aside';

export default ProductAside;
